import { emitClarityTrackEvent } from '../Clarity';

export const mapperToTrackEvent = clarityMapping => {
  return sortParameter => {
    if (!clarityMapping[sortParameter]) {
      if (process.env.NODE_ENV === 'production') {
        console.warn(`Clarity parameter ${sortParameter} missing!`);
      } else {
        throw new Error(`Clarity parameter ${sortParameter} missing!`);
      }
      return;
    }
    emitClarityTrackEvent(clarityMapping[sortParameter]);
  };
};

export const getCookie = name => {
  const value = document.cookie.split('; ').find(row => row.startsWith(name + '='));
  return value ? value.split('=')[1] : null;
};

export const parseConsentCookie = cookieValue => {
  if (!cookieValue) return {};
  return Object.fromEntries(
    cookieValue.split(',').map(pair => {
      const [key, value] = pair.split(':');
      return [key, value];
    }),
  );
};
